import { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { WorkspaceProvider, useWorkspace } from "./WorkspaceContext";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { Loading } from "./ui";
import HomeDashboard from "./HomeDashboard";
import SalesPage from "./SalesPage";
import MySpacePage from "./MySpacePage";
import TeamPage from "./TeamPage";
import OrganizationPage from "./OrganizationPage";
import EmployeesPage from "./EmployeesPage";
import TasksPage from "./TasksPage";
import CalendarPage from "./CalendarPage";
import ReportsPage from "./ReportsPage";
import AIAssistantPage from "./AIAssistantPage";
import SettingsPage from "./SettingsPage";
import Phase2Page from "./Phase2Page";

const PHASE2 = ["attendance", "leave", "helpdesk", "documents", "approvals", "hr-letters"];

const Body = () => {
  const { me, isManagerUp } = useWorkspace();
  if (!me) return <Loading />;
  if (me.error) return <p className="p-8 text-sm text-red-600" data-testid="ws-error">Could not load your workspace. Please sign in again.</p>;
  return (
    <Routes>
      <Route index element={<HomeDashboard />} />
      <Route path="sales/:tab?" element={<SalesPage />} />
      <Route path="my-space/:tab?" element={<MySpacePage />} />
      <Route path="team/:tab?" element={<TeamPage />} />
      <Route path="organization/:tab?" element={<OrganizationPage />} />
      <Route path="employees" element={isManagerUp ? <EmployeesPage /> : <Navigate to="/crm-app/team" replace />} />
      <Route path="tasks" element={<TasksPage />} />
      <Route path="calendar" element={<CalendarPage />} />
      <Route path="reports/:tab?" element={<ReportsPage />} />
      <Route path="ai" element={<AIAssistantPage />} />
      <Route path="settings/:tab?" element={<SettingsPage />} />
      {PHASE2.map((k) => <Route key={k} path={k} element={<Phase2Page module={k} />} />)}
      <Route path="*" element={<Navigate to="/crm-app" replace />} />
    </Routes>
  );
};

export const WorkspaceShell = () => {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem("crm_ws_sidebar") === "collapsed");
  const [mobileOpen, setMobileOpen] = useState(false);
  const toggle = () => {
    setCollapsed((c) => {
      localStorage.setItem("crm_ws_sidebar", c ? "open" : "collapsed");
      return !c;
    });
  };
  return (
    <WorkspaceProvider>
      <div className="min-h-screen bg-[#F3F4F6] font-body text-slate-800 flex" data-testid="crm-workspace">
        <Sidebar collapsed={collapsed} onToggle={toggle} mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />
        <div className="flex-1 min-w-0 flex flex-col">
          <TopBar onOpenMobile={() => setMobileOpen(true)} />
          <main className="flex-1 px-4 sm:px-6 lg:px-10 py-6 lg:py-8 max-w-[1500px] w-full mx-auto" data-testid="ws-main">
            <Body />
          </main>
        </div>
      </div>
    </WorkspaceProvider>
  );
};
